(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-error/assets/javascripts/page-error.js') >= 0) return;  svs.modules.push('/components/casino-react/page-error/assets/javascripts/page-error.js');
"use strict";


const {
  ReactIcon: Icon,
  ReactButton
} = svs.ui;
const ErrorPage = () => React.createElement("div", {
  className: "casino-react-page-error f-content align-center"
}, React.createElement(Icon, {
  className: "casino-react-page-error-icon",
  icon: "icecream",
  size: "1100"
}), React.createElement("h2", {
  className: "casino-react-page-error-title margin-bottom-1"
}, "N\xE5got gick snett!"), React.createElement("p", {
  className: "margin-bottom-1"
}, "Just nu g\xE5r det inte att l\xE4sa in v\xE5ra spel. F\xF6rs\xF6k igen om en liten stund."), React.createElement("br", null), React.createElement(ReactButton, {
  inverted: true,
  onClick: () => {
    window.location.reload();
  },
  size: 300
}, "F\xF6rs\xF6k igen"));
setGlobal('svs.components.casino_react.page_error', ErrorPage);

 })(window);